import { Typography, styled } from "@mui/material";
import { toolbarButtonName } from "../classes.js";
const Label = styled(Typography, {
  name: toolbarButtonName,
  slot: "Label",
  overridesResolver: (_props, styles) => [styles.label]
})(({ theme }) => ({
  display: "block",
  fontFamily: "inherit",
  fontSize: "inherit",
  maxWidth: theme.spacing(7),
  overflow: "hidden",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap"
}));
export {
  Label
};
//# sourceMappingURL=Label.js.map
